<template>
  <div class="max-w-full">

    <div v-if="loading">
      Loading...
    </div>

    <template v-else>

      <div class="mt-4 flex justify-between">
        <b class="text-2xl">Texty v aplikacii</b>
        <Button @click="saveTexts" :loading="saveing" label="Uložiť" class="w-[230px] "/>
      </div>

      <hr class="my-4">

      <div class="flex max-w-full font-bold border-b">
        <div class="flex-1">
          Klúč
        </div>
        <div class="flex-1">
          SK
        </div>
        <div class="flex-1">
          CZ
        </div>
        <div class="flex-1">
          EN
        </div>
        <div class="flex-1">
          DE
        </div>
      </div>

      <div v-for="(key,i) in skKeys" :key="i" class="flex max-w-full border-b">
        <div class="flex-1 flex items-center">
          {{ key }}
        </div>
        <div class="flex-1 flex items-center">
          <InputText id="title" v-model="texts.sk[key]" class="w-full" size="small"/>
        </div>
        <div class="flex-1 flex items-center">
          <InputText id="title" v-model="texts.cz[key]" class="w-full" size="small"/>
        </div>
        <div class="flex-1 flex items-center">
          <InputText id="title" v-model="texts.en[key]" class="w-full" size="small"/>
        </div>
        <div class="flex-1 flex items-center">
          <InputText id="title" v-model="texts.de[key]" class="w-full" size="small"/>
        </div>
      </div>

    </template>

  </div>
</template>

<script setup>
import {useToast} from "primevue/usetoast"
import {computed, reactive, ref, toRaw} from "vue"
import Supabase from "@/utils/Supabase.js"

const toast = useToast();
// const {data, error} = await Supabase.from('v2_Hajcer_App_Settings').update({
//     texts: appTexts
// }).eq('id', 'a1e147eb-f5a3-43db-af4c-39913302383d')
//
// console.log('texts updated', data, error)


const loading = ref(false)
const texts = ref({
  sk: {},
  en: {},
  cz: {},
  de: {}
})

const skKeys = computed(() => Object.keys(texts.value.sk))

const loadSettings = async () => {
  loading.value = true
  const {data, error} = await Supabase.from('v2_Hajcer_App_Settings').select().limit(1).single()
  console.log('texts', data.texts)
  if (error) {
    loading.value = false
    toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
  } else {

    try {

      Object.assign(texts.value.sk, data.texts.sk)
      Object.assign(texts.value.en, data.texts.en)
      Object.assign(texts.value.cz, data.texts.cz)
      Object.assign(texts.value.de, data.texts.de)

      loading.value = false

    } catch (e) {
      loading.value = false
      toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000})
    }

  }
}
loadSettings()

const saveing = ref(false)
const saveTexts = async () => {

  saveing.value = true
  const {data, error} = await Supabase.from('v2_Hajcer_App_Settings').update({
    texts: toRaw(texts.value)
  }).eq('id', 'a1e147eb-f5a3-43db-af4c-39913302383d').select().single()

  console.log('texts updated', data, error)
  if (error) {
    saveing.value = false
    toast.add({severity: 'error', summary: 'Error', detail: error.message, life: 3000});
  } else {
    saveing.value = false
    toast.add({severity: 'success', summary: 'Úspešne uložené', detail: 'Texty boli úspešne uložené', life: 3000});
  }

  await loadSettings()

}

</script>